export const efficiencySchema = {
  type: 'object',
  required: [
    'id',
    'curveSquareLoss',
    'curveProportionalLoss',
    'curveFixedLoss',
    'xaxisTitle',
    'yaxisTitle',
    'curveEquation',
  ],
  properties: {
    id: { type: 'string' },
    name: { type: ['string', 'null'] },
    family: { type: ['string', 'null'] },
    url: { type: ['string', 'null'] },
    curveEquation: { type: 'string', pattern: '^Efficiency$' },
    curveSquareLoss: { type: 'number' },
    curveProportionalLoss: { type: 'number' },
    curveFixedLoss: { type: 'number' },
    curveLoadMin: {
      type: 'number',
      exclusiveMaximum: { $data: '1/curveLoadMax' },
      default: 1,
    },
    curveLoadMax: {
      type: 'number',
      default: 100,
    },
    xaxisMin: {
      type: 'number',
      minimum: 0,
      exclusiveMaximum: { $data: '1/xaxisMax' },
      default: 0,
    },
    xaxisMax: {
      type: 'number',
      minimum: 0,
      maximum: 100,
      default: 100,
    },
    yaxisMin: {
      type: 'number',
      minimum: 0,
      exclusiveMaximum: { $data: '1/yaxisMax' },
      default: 0,
    },
    yaxisMax: {
      type: 'number',
      minimum: 0,
      maximum: 100,
      default: 100,
    },
    xaxisTitle: { type: 'string' },
    yaxisTitle: { type: 'string' },
    curveTestCondition: { type: ['string', 'null'] },
    printLabel: { type: 'string', default: '' },
  },
  if: {
    // disallow curve coefficients to all be 0
    properties: {
      curveSquareLoss: { const: 0 },
      curveProportionalLoss: { const: 0 },
      curveFixedLoss: { const: 0 },
    },
  },
  then: {
    properties: {
      curveSquareLoss: { const: 1 },
    },
  },
};
